import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base-service';
import { CitiesResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class CitiesService extends BaseService {
    private readonly citiesPath = '/locations/cities';

    private getCitiesUrl(): string {
        return `${this.getRootUrl()}${this.citiesPath}`;
    }

    getCities(countryCode: string, searchString: string): Observable<CitiesResponse> {
        const url = this.getCitiesUrl();
        const params = this.buildParams({ countryCode, searchString });
        return this.http.get<CitiesResponse>(url, { params });
    }
}
